import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { post } from "../../lib/request"

// Async thunk for verifying OTP
export const verifyOtp = createAsyncThunk("verifyOtp/verify", async ({ email, otp }, { rejectWithValue }) => {
  try {
    const response = await post(
      `authn/register/verify-otp?email=${encodeURIComponent(email)}&otp=${encodeURIComponent(otp)}`,
      null,
      { skipAuth: true },
    )
    return response
  } catch (error) {
    if (error?.code != null && error?.message != null) {
      return rejectWithValue({ code: error.code, message: error.message })
    }
    return rejectWithValue(error?.message)
  }
})

const initialState = {
  status: "idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
  data: null,
  isVerified: false,
  loading: false,
}

const verifyOtpSlice = createSlice({
  name: "verifyOtp",
  initialState,
  reducers: {
    clearVerifyOtpState: (state) => {
      state.status = "idle"
      state.error = null
      state.data = null
      state.isVerified = false
      state.loading = false
    },
    clearVerifyOtpError: (state) => {
      state.error = null
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(verifyOtp.pending, (state) => {
        state.status = "loading"
        state.loading = true
        state.error = null
        state.isVerified = false
      })
      .addCase(verifyOtp.fulfilled, (state, action) => {
        state.status = "succeeded"
        state.loading = false
        state.data = action.payload
        state.error = null
        state.isVerified = true
      })
      .addCase(verifyOtp.rejected, (state, action) => {
        state.status = "failed"
        state.loading = false
        state.error = action.payload
        state.isVerified = false
      })
  },
})

export const { clearVerifyOtpState, clearVerifyOtpError } = verifyOtpSlice.actions

export const clearVerifyOtp = clearVerifyOtpState

export default verifyOtpSlice.reducer
